import _ from "lodash";
import { store } from "@Store";
import { ATTACHMENT_FILE_ROUTE } from "@Helpers/urlHelpers";

export const getBackendUrl = () => {
  const state = store && store.getState();
  if (!_.get(state, "backendUrl") && !process.env.REACT_APP_CUBE_BACKEND) {
    return `${window.location.origin}/api-server`;
  }
  return _.get(state, "backendUrl") || process.env.REACT_APP_CUBE_BACKEND;
};

// The one place this URL is built, on web and — through the `@Utils` alias — on mobile too. It streams
// the file's own bytes under its recorded MIME type, so it drops straight into an `<img src>` or a link
// href; see "File uploads and downloads" in packages/web/src/features/forms/CLAUDE.md.
// `awsKey` is optional on the file-entry shape and several render sites read it unguarded, so the
// parameter stays wide rather than pushing a narrowing guard onto every call site.
export const attachmentFileUrl = (awsKey: string | undefined): string =>
  `${getBackendUrl()}${ATTACHMENT_FILE_ROUTE}/${awsKey}`;

export const getImageUrl = () => {
  const state = store && store.getState();
  if (!_.get(state, "imageUrl") && !process.env.REACT_APP_IMAGES_PUBLIC_URL) {
    return `${window.location.origin}/assets/images`;
  }
  return _.get(state, "imageUrl") || process.env.REACT_APP_IMAGES_PUBLIC_URL;
};

export const getStreamServerUrl = () => {
  const state = store && store.getState();
  if (!_.get(state, "streamServerUrl") && !process.env.REACT_APP_STREAMING_SERVER_PATH) {
    return `wss://${window.location.host}/stream-server`;
  }
  return _.get(state, "streamServerUrl") || process.env.REACT_APP_STREAMING_SERVER_PATH;
};

export const shouldShowSupport = (portalData?: { showSupport?: boolean } | null): boolean =>
  Boolean(portalData?.showSupport);

export const getSupportContactHref = (): string => `mailto:${process.env.REACT_APP_CUBE_SUPPORT_EMAIL}`;
